// import { Grid, TextField } from "@mui/material";
// import SearchableInput from "../Dashboard/Components/SearchableInput";

// export const LogFilter = ({ filter, setFilter, clearAll }: any) => {
//     return (
//         <Grid item container spacing={1}>
//             <Grid item xs={12} md={6}>
//                 {/* <MultiPermissionAuthorize ops={["READ DATE"]}> */}
//                 <TextField
//                     size="small"
//                     name="date"
//                     type="date"
//                     label="Day"
//                     fullWidth
//                     value={filter.date}
//                     InputLabelProps={{ shrink: true }}
//                     onChange={(ev) =>
//                         setFilter({ ...filter, date: ev.target.value })
//                     }
//                 />
//                 {/* </MultiPermissionAuthorize> */}
//             </Grid>

//             <Grid item xs={12} md={6}>
//                 <SearchableInput
//                     api="/user"
//                     label="Operator"
//                     filter={filter}
//                     setFilter={setFilter}
//                     clearAll={clearAll.operator}
//                 />
//             </Grid>
//         </Grid>
//     );
// };

import { Grid, TextField } from "@mui/material";
import SearchableInput from "../Dashboard/Components/SearchableInput";

export const LogFilter = ({ filter, setFilter, clearAll }: any) => {
    return (
        <Grid item container spacing={1}>
            <Grid item xs={12} md={3}>
                <TextField
                    size="small"
                    name="startDate"
                    type="date"
                    label="Start Date"
                    fullWidth
                    value={filter.startDate}
                    InputLabelProps={{ shrink: true }}
                    onChange={(ev) =>
                        setFilter({ ...filter, startDate: ev.target.value })
                    }
                />
            </Grid>

            <Grid item xs={12} md={3}>
                <TextField
                    size="small"
                    name="endDate"
                    type="date"
                    label="End Date"
                    fullWidth
                    value={filter.endDate}
                    InputLabelProps={{ shrink: true }}
                    onChange={(ev) =>
                        setFilter({ ...filter, endDate: ev.target.value })
                    }
                />
            </Grid>

            <Grid item xs={12} md={6}>
                <SearchableInput
                    api="/user"
                    label="Operator"
                    filter={filter}
                    setFilter={setFilter}
                    clearAll={clearAll.operator}
                />
            </Grid>
        </Grid>
    );
};
